import styled from "styled-components";

const HeaderWrapper = styled.div`
  width: ${(props) => (props.fullWidth ? "100%" : "800px")};
  font-family: Rubik;
  font-style: normal;
  letter-spacing: 0px;
  text-align: center;
  color: #1e1f46;
  margin: 0 auto;
  position: relative;
`;
const Title = styled.div`
  width: 100%;
  font-size: 24px;
  font-weight: 500;
  line-height: 26px;
  margin-top: ${(props) => (props.withMargin ? "30px" : "0px")};
`;
const Description = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  opacity: 0.8;
  padding: 20px;
`;

export { HeaderWrapper, Title, Description };
